<template>
  <div class="container">
    <div
      v-show="message.state"
      class="alert alert-dismissible border-0 fade show"
      :class="message.type"
      role="alert"
    >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>{{ message.msg }}</strong>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="metamask" class="card">
          <div class="card-body">
            <h2 class="card-title">Asset Information</h2>
            <!--<h4>{{ currents }}</h4>-->
            <br />
            <!--Name and Category -->
            <form>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Asset Name</label>
                  <input
                    v-model="asset_name"
                    type="text"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Category</label>
                  <v-select
                    v-model="asset_category_selected"
                    :options="[
                      'Office',
                      'Hotel',
                      'Multifamily',
                      'Residential',
                      'Retail',
                      'Alternative',
                    ]"
                  ></v-select>
                </div>
              </div>
              <!--Country and Cadastral Number -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Country</label>
                  <v-select
                    v-model="asset_country_selected"
                    :options="country_list"
                  ></v-select>
                </div>
                <div class="form-group col-md-6">
                  <label>Cadastral Number</label>
                  <input
                    v-model="asset_cadastral_number"
                    type="text"
                    class="form-control"
                  />
                  <!--<div class="invalid-feedback">
            Sorry, that username's taken. Try another?
          </div>-->
                </div>
              </div>
              <!--City and Trade representative -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>City</label>
                  <input
                    v-model="asset_city"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group col-md-6">
                  <label>Trade Representative</label>
                  <input
                    v-model="asset_trade_representative"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <!-- Address and representative email-->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Address</label>
                  <textarea
                    v-model="asset_address"
                    class="form-control"
                    rows="3"
                    placeholder="Text Here..."
                  ></textarea>
                </div>
                <div class="form-group col-md-6">
                  <label>Trade Representative's E-mail</label>
                  <input
                    v-model="asset_trade_rep_email"
                    type="email"
                    class="form-control"
                  />
                </div>
              </div>

              <br />
              <h3>Asset documents</h3>
              <hr />
              <!--Row 1 documents -->
              <div class="form-row ml-5">
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputProjectDocument">
                    Project
                  </h5>
                  <div class="custom-file text-center img-fluid">
                    <input
                      id="inputProjectDocument"
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(1)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputProjectDocument"
                    >
                      <img
                        v-if="!loaded_documents.project"
                        id="inputProjectDocument"
                        class="img-fluid icon"
                        src="../../../public/icons/upload_document_icon.png"
                        alt="Upload project document icon"
                      />
                      <img
                        v-else
                        id="inputProjectDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload project document icon"
                      />

                      <p v-if="!loaded_documents.project">Upload file</p>
                      <p v-else>Uploaded file</p>
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputTransmitterDocument">
                    Transmitter
                  </h5>
                  <div class="custom-file text-center">
                    <input
                      id="inputTransmitterDocument"
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(2)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputTransmitterDocument"
                    >
                      <img
                        v-if="!loaded_documents.transmitter"
                        id="inputTransmitterDocument"
                        class="img-fluid icon"
                        src="../../../public/icons/upload_document_icon.png"
                        alt="Upload transmitter document icon"
                      />
                      <img
                        v-else
                        id="inputTransmitterDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload transmitter document icon"
                      />
                      <p v-if="!loaded_documents.transmitter">Upload file</p>
                      <p v-else>Uploaded file</p>
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputLegaInformationDocument">
                    Legal information
                  </h5>
                  <div class="custom-file text-center">
                    <input
                      id="inputLegaInformationDocument"
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(3)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputLegaInformationDocument"
                    >
                      <img
                        v-if="!loaded_documents.legal"
                        id="inputLegaInformationDocument"
                        class="img-fluid icon"
                        src="../../../public/icons/upload_document_icon.png"
                        alt="Upload legal information document icon"
                      />
                      <img
                        v-else
                        id="inputLegaInformationDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload legal information document icon"
                      />
                      <p v-if="!loaded_documents.legal">Upload file</p>
                      <p v-else>Uploaded file</p>
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h6 class="text-center" for="inputCommercialDossietDocument">
                    Commercial Dossier
                  </h6>
                  <div class="custom-file text-center">
                    <input
                      id="inputCommercialDossietDocument"
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(4)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputCommercialDossietDocument"
                    >
                      <img
                        v-if="!loaded_documents.dossier"
                        id="inputCommercialDossietDocument"
                        class="img-fluid icon"
                        src="../../../public/icons/upload_document_icon.png"
                        alt="Upload commercial dossier document icon"
                      />
                      <img
                        v-else
                        id="inputCommercialDossietDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload commercial dossier document icon"
                      />
                      <p v-if="!loaded_documents.dossier">Upload file</p>
                      <p v-else>Uploaded file</p>
                    </label>
                  </div>
                </div>
                <div
                  class="form-group col-md-2 col-sm-3"
                  style="margin-bottom: 60px;"
                >
                  <h5 class="text-center" for="inputCadastralDocument">
                    Cadastral
                  </h5>
                  <div class="custom-file text-center">
                    <input
                      id="inputCadastralDocument"
                      type="file"
                      class="custom-file-input"
                      style="display: none;"
                      @change="list_files.push($event.target.files[0])"
                      @click="change_logo(5)"
                    />
                    <label
                      class="btn btn-outline-primary btn-rounded text-center"
                      for="inputCadastralDocument"
                    >
                      <img
                        v-if="!loaded_documents.cadastral"
                        id="inputCadastralDocument"
                        class="img-fluid icon"
                        src="../../../public/icons/upload_document_icon.png"
                        alt="Upload cadastral document icon"
                      />
                      <img
                        v-else
                        id="inputCadastralDocument"
                        class="img-fluid icon_loaded"
                        src="../../../public/icons/check.png"
                        alt="Upload cadastral document icon"
                      />
                      <p v-if="!loaded_documents.cadastral">Upload file</p>
                      <p v-else>Uploaded file</p>
                    </label>
                  </div>
                </div>
              </div>

              <br />
              <br />
              <br />
              <!-- Switch  -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Do you want upload more documents?</label>
                  <div class="custom-control custom-switch">
                    <input
                      id="customSwitch1"
                      v-model="flag_extraDocs"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="customSwitch1">
                      No / Yes
                    </label>
                  </div>
                </div>
              </div>
              <div v-show="flag_extraDocs">
                <div class="form-row">
                  <h5>Click to upload more documents</h5>
                  <div class="custom-file form-col">
                    <input
                      id="MoreFiles"
                      type="file"
                      multiple
                      accept="application/pdf"
                      class="custom-file-input"
                      style="display: none;"
                      @change="
                        list_extraDocs = $event.target.files;
                        flag_show = true;
                      "
                    />
                    <label class="btn btn-outline-primary" for="MoreFiles">
                      Upload
                    </label>
                  </div>
                </div>
                <div v-if="list_extraDocs.length > 5" class="form-row">
                  <div
                    class="alert alert-warning alert-dismissible fade show"
                    role="alert"
                  >
                    You can to upload only <strong> 5 file more!</strong>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="form-row">
                  <div v-show="flag_show && list_extraDocs.length < 5">
                    <br />
                    <h5>List of documents to upload:</h5>
                    <div>
                      <li v-for="(Docs, index) in list_extraDocs" :key="index">
                        {{ Docs.name }}
                      </li>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <br />
              <br />
              <!-- Switch  -->
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Is this project being built?</label>
                  <div class="custom-control custom-switch">
                    <input
                      id="customSwitch2"
                      v-model="checked"
                      type="checkbox"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="customSwitch2">
                      No / Yes
                    </label>
                  </div>
                </div>
                <div class="form-group col-md-6"></div>
              </div>
              <!-- Stages Section  -->
              <div v-show="checked" class="construction-fields">
                <br />
                <h3>Construction stages</h3>
                <hr />
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label>Start of construction</label>
                    <div class="form-group">
                      <input
                        v-model="asset_date_start"
                        type="date"
                        class="form-control"
                        @click="calculate_stages"
                      />
                    </div>
                  </div>

                  <div class="form-group col-md-4">
                    <label>Deadline of construction</label>
                    <div class="form-group">
                      <input
                        v-model="asset_date_end"
                        type="date"
                        class="form-control"
                        @click="calculate_stages"
                      />
                    </div>
                  </div>

                  <div class="form-group col-md-4">
                    <label>Stage Numbers</label>
                    <div class="input-group">
                      <input
                        v-model="asset_stage_number"
                        type="text"
                        class="form-control"
                        @keyup="calculate_stages"
                        @keyup.enter="calculate_stages"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-outline-primary"
                          type="button"
                          @click="calculate_stages"
                        >
                          Calculate stages
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--autogenerated -->
                <div v-show="array_dates" class="form-row">
                  <div
                    v-for="(date, index) in array_dates"
                    :key="index"
                    class="form-group col-lg-4"
                  >
                    <label>Start stage {{ doMath(index) }}</label>
                    <div class="form-group">
                      <input type="date" :value="date" disabled />
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <hr />
            </form>
            <div class="text-right">
              <button
                type="button"
                class="btn btn-outline-success btn-rounded"
                @click="complete_information()"
              >
                <i class="fas fa-check"></i> Save
              </button>
              <br />
              <br />
            </div>
          </div>
        </div>
        <div v-else class="card metamask_card text-center">
          <div class="card-body">
            <img
              class="alert_icon"
              src="../../../public/icons/alert-triangle_3.svg"
              alt="alert_icon"
            />
            <h2 class="card-title text-danger">Metamask is not installed!</h2>
            <p>
              Please press the button below to download it.
            </p>
            <div>
              <button
                type="button"
                class="btn btn-outline-primary btn-rounded download_btn"
                @click="downloadMetamask"
              >
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './styles/asset_styles.css'; /* switch Button styles*/

#upload_document_icon {
  width: 80px;
  padding: 10px;
}

.icon {
  width: 80px;
  padding: 10px;
}

.icon_loaded {
  width: 70px;
  height: 70px;
  padding: 10px;
}

.download_btn {
  padding: 1rem 5rem;
}

.alert_icon {
  height: 7rem;
  width: 7rem;
  margin-bottom: 1rem;
}

.metamask_card {
  height: 22rem;
}
</style>

<script>
import * as moment from 'moment/moment';
import * as move_tabs from './js/movetabs.js';
import MetaMaskOnboarding from '@metamask/onboarding';

export default {
  name: 'AssetInformation',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      loaded_documents: {
        project: false,
        transmitter: false,
        legal: false,
        dossier: false,
        cadastral: false,
        others: false,
      },
      checked: false,
      userId: '',
      assetId: '',
      asset_name: '',
      asset_category_selected: '',
      asset_country_selected: '',
      asset_cadastral_number: '',
      asset_city: '',
      asset_trade_representative: '',
      asset_address: '',
      asset_trade_rep_email: '',
      asset_date_start: '',
      asset_date_end: '',
      asset_stage_number: 0,
      country_list: [],
      asset_categories: [],
      array_dates: [],
      list_files: [],
      files_uploaded: false,
      flag_extraDocs: false,
      list_extraDocs: [],
      flag_show: false,
      email: '',
      metamask: false,
    };
  },
  created() {
    const ethereum = window.ethereum;

    if (typeof ethereum !== 'undefined') {
      this.metamask = true;
    }

    this.loadJSONCountries();
    this.userId = JSON.parse(localStorage.getItem('user')).userId;
    this.email = JSON.parse(localStorage.getItem('user')).email;
  },
  methods: {
    imprimir(algo) {
      console.log(algo);
    },
    complete_information() {
      this.message.state = false;
      if (!this.emptyFields()) {
        this.$http
          .post(`/asset/register`, {
            userId: this.userId,
            assetName: this.asset_name,
            category: this.asset_category_selected,
            country: this.asset_country_selected,
            cadastralNumber: this.asset_cadastral_number,
            city: this.asset_city,
            tradeRepresentative: this.asset_trade_representative,
            tradeRepresentativeEmail: this.asset_trade_rep_email,
            address: this.asset_address,
          })
          .then(resp => {
            this.message.type = 'alert-success';
            this.message.msg = 'Asset created successfully';
            this.message.state = true;

            // get the assetId of the response and store it in localstorage
            this.assetId = resp.data.assetId;
            let asset = {
              assetId: this.assetId,
              assetName: this.asset_name,
            };
            localStorage.setItem('asset', JSON.stringify(asset));
            // if the user add construction stages,
            //an update request is sent with the dates of the stages
            if (this.asset_stage_number > 0) {
              this.sendUpdateAssetRequestWithDate();
            }
            // send the documents
            if (this.list_files.length > 0) {
              this.uploadDocuments();
            }
            //if (this.files_uploaded) {
            // if they loaded successfully wait a few seconds and change the tab
            this.scrollNavigator();
            this.changeTabAndNextStep();
            // }
          })
          .catch(err => {
            this.message.msg = err.response.data.message;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.scrollNavigator();
          });
      } else {
        /* if (this.list_files.length < 5) {
          this.message.type = 'alert-warning';
          this.message.msg = 'You need to upload all the documents to continue';
          this.message.state = true;
          this.scrollNavigator();
        } else {*/
        this.message.type = 'alert-warning';
        this.message.msg = 'One or more fields remain to be completed';
        this.message.state = true;
        this.scrollNavigator();
        //}
      }
    },
    uploadDocuments() {
      console.log(this.list_files);
      const formData = new FormData();
      formData.append('projectDocument', this.list_files[0]);
      formData.append('transmitterDocument', this.list_files[1]);
      formData.append('legalInformationDocument', this.list_files[2]);
      formData.append('commercialDossierDocument', this.list_files[3]);
      formData.append('cadastralDocument', this.list_files[4]);

      this.$http
        .post(
          `/asset/uploadDocuments?email=${this.email}&_id=${this.assetId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then(resp => {
          if (this.flag_extraDocs) {
            this.sendExtraDocs();
          } else {
            this.files_uploaded = true;
            this.message.type = 'alert-success';
            this.message.msg = 'Files uploaded successfully';
            this.message.state = true;
            this.scrollNavigator();
          }
          return resp;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
          console.log(err);
        });
    },
    sendExtraDocs() {
      const formData = new FormData();
      Array.from(Array(this.list_extraDocs.length).keys()).map(x => {
        formData.append('extraDoc', this.list_extraDocs[x]);
      });

      this.$http
        .post(
          `/asset/info/Doc/Extras?id=${this.assetId}&email=${this.email}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then(resp => {
          this.files_uploaded = true;
          this.message.type = 'alert-success';
          this.message.msg = 'Files uploaded successfully';
          this.message.state = true;
          this.scrollNavigator();
          return resp;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
          console.log(err);
        });
    },
    sendUpdateAssetRequestWithDate() {
      this.$http
        .put(`/asset/underConstruction`, {
          startDate: new Date(this.asset_date_start),
          deadlineDate: new Date(this.asset_date_end),
          stages: parseInt(this.asset_stage_number),
          _id: this.assetId,
        })

        .then(resp => {
          this.message.type = 'alert-success';
          this.message.msg = resp.data.message;
          this.message.state = true;
          this.scrollNavigator();
          return;
        })
        .catch(err => {
          this.message.msg = err.response.data.message;
          this.message.type = 'alert-warning';
          this.message.state = true;
          this.scrollNavigator();
          return;
        });
    },
    loadJSONCountries() {
      // load the list of countries for the selection of the country of the asset
      this.countries = require('../account/countries.json');
      for (let i = 0; i < this.countries.length; i++) {
        this.country_list.push(this.countries[i].name);
      }
    },
    calculate_stages() {
      // mathematical calculation for intermediate dates between stages
      let n = this.asset_stage_number;
      if (n > 0 && this.asset_date_start != '' && this.asset_date_end != '') {
        let start = moment(this.asset_date_start);
        let end = moment(this.asset_date_end);
        if (start < end) {
          let diff_days = end.diff(start, 'days');
          let k = Math.round(diff_days / n); //Number of days by stage
          let stages = [];
          stages[0] = start;

          let dates = [];
          dates[0] = start.format('YYYY-MM-DD').toString();
          var i = 2;
          while (n >= i) {
            let days = (i - 1) * k;
            let newStage = moment(stages[0])
              .add(days, 'days')
              .format('YYYY-MM-DD');
            stages[i - 1] = newStage;
            dates[i - 1] = newStage.toString();
            i++;
          }
          this.array_dates = dates;
        }
      }
    },
    doMath: function(index) {
      // List the stages starting with 1 instead of 0
      // functionality used in the dynamic calculation of stages
      return index + 1;
    },
    changeTabAndNextStep() {
      // wait 2 seconds to change the panel and move the step-bar
      setTimeout(() => {
        this.$emit('update', 2);
        move_tabs.moveTab();
      }, 2000);
    },
    scrollNavigator() {
      // scroll to the top of the browser
      // so that the user can view the alert
      window.scroll({
        top: -5000,
        behavior: 'smooth',
      });
    },
    emptyFields() {
      return (
        this.asset_name == '' ||
        this.asset_category_selected == '' ||
        this.asset_country_selected == '' ||
        this.asset_cadastral_number == '' ||
        this.asset_city == '' ||
        this.asset_trade_representative == '' ||
        this.asset_address == '' ||
        this.asset_trade_rep_email == ''
      );
    },
    change_logo(number) {
      setTimeout(() => {
        switch (number) {
          case 1:
            this.loaded_documents.project = true;
            break;
          case 2:
            this.loaded_documents.transmitter = true;
            break;
          case 3:
            this.loaded_documents.legal = true;
            break;
          case 4:
            this.loaded_documents.dossier = true;
            break;
          case 5:
            this.loaded_documents.cadastral = true;
            break;
          case 6:
            this.loaded_documents.others = true;
            break;
        }
      }, 2000);
    },
    downloadMetamask() {
      const onboarding = new MetaMaskOnboarding();
      onboarding.startOnboarding();
    },
  },
};
</script>
